<template lang="pug">
  ods-dropdown(
    :hide-on-click='false'
    icon='setting'
    @visible-change='handleVisibleChange')
    ods-dropdown-menu.popover-columns.desplegable(slot='dropdown')
      h3.titulosetting {{ $t('msg_generics.filter_table_menu') }}
      ods-dropdown-item(
        v-for='(column, index) in columns',
        :key='index')
        ods-checkbox(
          @input='handlerShowColumns(column)',
          v-model='column.show')
          | {{ column.text }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'b2b-table-menu-servicios',
  props: [],
  data () {
    return {
      columns: [],
      column: {}
    }
  },
  computed: {
    ...mapGetters([
      'isShowNameServices',
      'isShowCodeServices',
      'isShowIsSenderServices',
      'isShowIsReceiverServices',
      'isShowCreationDateTimeServices',
      'isShowStatusServices'
    ])
  },
  methods: {
    ...mapActions([
      'isShowNameServicesAction',
      'isShowCodeServicesAction',
      'isShowIsSenderServicesAction',
      'isShowIsReceiverServicesAction',
      'isShowCreationDateTimeServicesAction',
      'isShowStatusServicesAction'
    ]),

    handlerShowColumns (col) {
      console.log('handlerShowColumns en B2bTable: ', col)
      const column = col.value
      let isShow
      switch (column) {
        case 'nombre':
          isShow = !this.isShowNameServices
          this.isShowNameServicesAction(isShow)
          break
        case 'codigo':
          isShow = !this.isShowCodeServices
          this.isShowCodeServicesAction(isShow)
          break
        case 'emision':
          isShow = !this.isShowIsSenderServices
          this.isShowIsSenderServicesAction(isShow)
          break
        case 'recepcion':
          isShow = !this.isShowIsReceiverServices
          this.isShowIsReceiverServicesAction(isShow)
          break
        case 'fecha':
          isShow = !this.isShowCreationDateTimeServices
          this.isShowCreationDateTimeServicesAction(isShow)
          break
        case 'estado':
          isShow = !this.isShowStatusServices
          this.isShowStatusServicesAction(isShow)
          break
        default:
          break
      }
    },
    handleVisibleChange () {
      this.chargeFilters()
    },
    chargeFilters () {
      this.columns = [
        {
          text: this.$t('projects.entity_table.name'), value: 'nombre', show: this.isShowNameServices
        }, {
          text: this.$t('projects.entity_table.code'), value: 'codigo', show: this.isShowCodeServices
        }, {
          text: this.$t('projects.entity_table.issuing'), value: 'emision', show: this.isShowIsSenderServices
        }, {
          text: this.$t('projects.entity_table.reception'), value: 'recepcion', show: this.isShowIsReceiverServices
        }, {
          text: this.$t('projects.entity_table.creation_date'), value: 'fecha', show: this.isShowCreationDateTimeServices
        }, {
          text: this.$t('projects.entity_table.enabled'), value: 'estado', show: this.isShowStatusServices
        }
      ]
    }
  },
  created () {
    this.chargeFilters()
  }
}
</script>

<style lang="scss" scoped>
 .ods-dropdown {
    display: flex;
}
.desplegable {
    top: 180px !important
}
.titulosetting {
      padding: 10px;
}
</style>
